"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGameCardTitle = exports.StyledGameCardImage = exports.StyledGameCard = void 0;
const rn_css_1 = __importDefault(require("rn-css"));
const base_ui_theme_colors_1 = require("@unboared/base-ui.theme.colors");
const base_ui_text_heading_1 = require("@unboared/base-ui.text.heading");
exports.StyledGameCard = rn_css_1.default.TouchableOpacity `
    ${props => props.active && `-ms-transform: scale(1.15);
        -webkit-transform: scale(1.15);
        transform: scale(1.15);
        transition-duration: 500ms;`}
`;
exports.StyledGameCardImage = rn_css_1.default.Image ` 
    width: 100%;
    height: 80%;
    opacity: ${props => props.disable ? 0.2 : 1.0};
    border-radius: ${props => 0.15 * props.size};
    border: ${props => 0.035 * props.size} solid ${({ disable, active, theme }) => active ? (disable ? theme.currentPalette.c100 : base_ui_theme_colors_1.color.primary) : 'rgba(0,0,0,0)'};    
`;
exports.StyledGameCardTitle = (0, rn_css_1.default)(base_ui_text_heading_1.Heading) `
    font-size: ${props => props.fontSize};
    opacity: ${props => props.disable ? 0.2 : 1.0};
    ${props => props.active &&
    `color: ${(props.disable ? props.theme.currentPalette.c100 : base_ui_theme_colors_1.color.primary)};`}
`;
//# sourceMappingURL=StyledGameCard.js.map